import { useEffect } from 'react'

import { EDITOR_TOOLS } from '@editor/config/constants'
import { useEditorContext } from '@editor/contexts/Editor'

const ToolAutoSelector = () => {
  const { changeTool, initCompleted } = useEditorContext()

  /**
   * Auto-switch tool based on URL hash (#tool-<key>).
   * We only do it once on load then clears it.
   */
  useEffect(() => {
    if (!initCompleted) return

    const hashes = window.location.hash.split('#')
    const toolHash = hashes.find((hash) => hash.startsWith('tool-'))
    if (toolHash) {
      const tool = toolHash.replace('tool-', '')
      if (tool in EDITOR_TOOLS) {
        changeTool(tool)

        // get all hash and remove ones starting with 'tool'
        const cleanedHashes = window.location.hash
          .split('#')
          .filter((hash) => !hash.startsWith('tool-'))
          .join('#')

        document.dispatchEvent(
          new CustomEvent('app:navigate', {
            detail: { url: window.location.pathname + window.location.search + cleanedHashes, replace: true },
          }),
        )
      }
    }
  }, [changeTool, initCompleted])

  return null
}

export default ToolAutoSelector
